import { BadgeType, IconItem } from '@scaleaq/scaleui';
import { BargeControlAlarmState } from '@scaleaq/sitecontrol-lib';

import { Icon } from '@/utils';

import type { OnAcknowledge } from './alarmBadge.types.ts';

export const getBadgeType = (
  alarmState: BargeControlAlarmState,
  showHealthyStatus: boolean
): BadgeType | undefined => {
  switch (alarmState) {
    case BargeControlAlarmState.UnacknowlegeActiveAlarm:
    case BargeControlAlarmState.AcknowledgeActiveAlarm:
      return 'alarm';
    case BargeControlAlarmState.UnacknowledgeClearedAlarm:
      return 'neutral';
    case BargeControlAlarmState.Healthy:
      return showHealthyStatus ? 'success' : undefined;
    default:
      return undefined;
  }
};

export const getToolbarActionList = (
  alarmState: BargeControlAlarmState,
  label: string,
  onAcknowledge?: OnAcknowledge
): IconItem[] => {
  const toolbarActionList: IconItem[] = [];
  switch (alarmState) {
    case BargeControlAlarmState.UnacknowlegeActiveAlarm:
      toolbarActionList.push({
        label,
        id: 'barge-alarm-ack-unacked-active',
        onClick: () =>
          onAcknowledge ? onAcknowledge(BargeControlAlarmState.AcknowledgeActiveAlarm) : undefined,
        Icon: Icon.Check,
      });
      break;
    case BargeControlAlarmState.UnacknowledgeClearedAlarm:
      toolbarActionList.push({
        label,
        id: 'barge-alarm-ack-unacked-cleared',
        onClick: () => (onAcknowledge ? onAcknowledge(BargeControlAlarmState.Healthy) : undefined),
        Icon: Icon.Check,
      });
      break;
    default:
      break;
  }

  return toolbarActionList;
};
